<template>
  <b-card title="Manage ads.txt">
    <b-alert show variant="light">
      These ads.txt entries are automatically generated based on demand partner profiles.
      If you have a direct billing relationship with a partner, their direct entries will be shown instead of
      their reseller. If you have questions about particular entries, please contact the demand partner directly.
    </b-alert>

    <b-form-textarea rows="10" max-rows="50" :value="entry" readonly />
  </b-card>
</template>

<script>
  import {PublisherApi} from "../api"

  export default {
      name: 'PublisherAdsTxt',
      props: {
          cid: { required: true },
          mid: { required: true }
      },
      created () {
          PublisherApi.adsTxt(this.cid, this.mid).then((entries) => {
              this.entries = entries
          }).catch((e) => {
              this.$notify.error("Error building entries")
          })
      },
      data () {
          return {
              entries: []
          }
      },
      computed: {
          entry () {
              let list = []
              list.push("#SmartRTB")
              list.push("smrtb.com, " + this.cid + ", DIRECT")
              for (let e of this.entries) {
                  list.push(e.ads_txt)
              }
              return list.join("\r\n")
          }
      }
  }
</script>



// WEBPACK FOOTER //
// src/publisher/pages/PublisherAdsTxt.vue